/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */


expocadfx.setupHeaderFooter = function() {
	'use strict';
    var data = expocadfx.fxData;
    var config = expocadfx.config;
    var fxStyle = expocadfx.styles;
    var txt = expocadfx.txt;
    var elem = expocadfx.element;
    var elemById = elem.elementById;
    
    var doc = document;
    var clrMainBg = "";
    var clrMainText = "";
    
	var bars = null;
	var i = 0;
	var logo = null;
	var headerUsed = false;
	var clrs = null;
	var div = null;
	var viewTitleOffset = 10;

	elemById( "load").textContent = txt.LOADING;

	clrMainBg = fxStyle.mainHeader.clrBg;
	clrMainText = fxStyle.mainHeader.clrText;
		// if no color provided for header text, pick one that will show up
	if( clrMainText ==="") {        //  select a contrasting color
		clrs = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(clrMainBg);
		if( 0.299 * parseInt(clrs[1], 16) + 
			0.587 * parseInt(clrs[2], 16) + 0.114 * parseInt(clrs[3], 16) > 180) {

			clrMainText = "#000000";
		}
		else {
			clrMainText = "#ffffff";
		}
		fxStyle.mainHeader.clrText = clrMainText;
	}

	if( config.hdrLogoSource !== "") {
		logo = elemById( "logo");
		logo.alt = "Event Logo";
		logo.src = config.hdrLogoSource;
		// Not sure why Jim added this? -ANH 12/6/2018
		//logo.style.maxWidth = data.viewportWidth;

		if( config.urlFacilityView !== "") {
			if( config.urlFacilityView.substr( 0, 4) !== "http") {
				config.urlFacilityView = "http://" + config.urlFacilityView;
			}
			elemById( "logoLink").setAttribute( "href", config.urlFacilityView);
			elemById( "logoLink").setAttribute( "target", "_blank");
		}
		headerUsed = true;
	}
	else {
		elemById( "mainHeader").removeChild( elemById( "logodiv"));
	}
	elemById( "mainHeader").style.backgroundColor = clrMainBg;
	if( fxStyle.mainHeader.gradBg !== "") {
		elemById( "mainHeader").style.background = fxStyle.mainHeader.gradBg;
	}

	elemById( "mainHeader").style.color = clrMainText;


	elemById( "btnMenu").style.backgroundColor = fxStyle.windowHeader.clrBg !== "" ?
					fxStyle.windowHeader.clrBg : clrMainBg;
	elemById( "btnMenu").style.color = fxStyle.windowHeader.clrText !== "" ?
					fxStyle.windowHeader.clrText : clrMainText;

	if (!config.isXML && !config.noNav && config.exhibitorDirectory) {
		document.body.classList.add('directoryFloorMenu');
	}

	bars = elemById( "menuSymbol").getElementsByTagName( "div");

	for( i = 0; i < 3; i++) {
		bars[i].style.backgroundColor = elemById( "btnMenu").style.color;
	}

	if( config.eventTitle !== "") {
		if( config.eventTitleLocation.toLowerCase() === "header" && !config.exhibitorDirectory) {
			elemById( "etitle").textContent = config.eventTitle;
			if( config.clrEventTitleText !== "") {
				elemById( "etitle").style.color = config.clrEventTitleText;
			}
			elemById( "etitle").style.fontSize = config.eventTitleTextSize + "px";
			headerUsed = true;
		}
		else {
			elemById( "etitle").textContent = "";
			if( config.eventTitleLocation.toLowerCase() === "drawing") {
				div = doc.createElement( "div");
				elemById( "floorplan").appendChild( div);
				div.className = "drawingEventTitle";
				div.textContent = config.eventTitle;
				viewTitleOffset = parseInt( config.eventTitleTextSize, 10) + 14;
			}
		}
	}

	if( config.hasMultipleViews) {
		if( config.viewTitleLocation.toLowerCase() === "header" && !config.exhibitorDirectory) {
			if( config.eventTitleLocation.toLowerCase() !== "header") {
				elemById( "etitle").textContent = config.viewTitle;
			}
			else {
				elemById( "vtitle").textContent = config.viewTitle;

			}
			if( config.clrViewTitleText !== "") {
				elemById( "vtitle").style.color = config.clrViewTitleText;
			}
			elemById( "vtitle").style.fontSize = config.viewTitleTextSize + "px";
			headerUsed = true;
		}
		else if( config.viewTitleLocation.toLowerCase() === "drawing") {
			div = doc.createElement( "div");
			elemById( "floorplan").appendChild( div);
			div.style.position = "absolute";
			div.style.top = viewTitleOffset + "px";
			div.style.width = "100%";
			div.style.textAlign = "center";
			div.style.fontSize = config.viewTitleTextSize + "px";
			div.style.color = config.clrViewTitleText;
			div.style.zIndex = "1";
			div.textContent = config.viewTitle;
		}
	}
	else {
		elemById( "vtitle").textContent = "";
	}

	// For now, disable header if exhibitor directory / directoryNav is enabled
	// Try to find way to merge header into directoryNav
	if(!config.noNav && config.exhibitorDirectory){ 
		elemById( "mainHeader").style.display = "none";
	}

	if( !headerUsed && !config.bSocialButtons) {
		elemById( "mainHeader").style.display = "none";
	}

	elemById( "ftr").style.backgroundColor = fxStyle.footer.clrBg;
	if( fxStyle.footer.gradBg !== "") {
		elemById( "ftr").style.background = fxStyle.footer.gradBg;
	}
	elemById( "ftr").style.color = fxStyle.footer.clrText !== "" ? 
		fxStyle.footer.clrText : fxStyle.mainHeader.clrText;
};